import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { Utils } from '../../utils/utils';
import { useBookmarks } from '../../hooks/useBookmarks';
import './livro.css';

import {
  Preloader
} from '../../components';
import AuthorService from '../../services/AuthorService';

export default class ViewLivro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "url": null,
      "book": null,
      "contentUid": null,
      "referenceUid": null,
      "bookmarks": [],
      "lastInteraction": null,
      "summary": null,
      "summaryLoading": false
    }
    
    this.handleBookmarkEvent = this.handleBookmarkEvent.bind(this);
  }

  componentDidMount() {
    this.getReferences();
    // Escutar eventos de marcações do player
    window.addEventListener('message', this.handlePlayerMessage);
    // Escutar eventos de botão voltar do player
    window.addEventListener('message', this.handleBackButtonMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handlePlayerMessage);
    window.removeEventListener('message', this.handleBackButtonMessage);
  }

  handleBackButtonMessage = (event) => {
    if (event.data.type === 'BACK_BUTTON_CLICKED' || event.data.onBack) {
      this.redirectTo("/");
    }
  }

  handlePlayerMessage = async (event) => {
    if (!event.data || typeof event.data !== 'object') return;

    this.sendAppVersion();

    const { userInteraction, requestHighlights, createCitation, requestSummary } = event.data;
    
    if (requestHighlights) {
      // Enviar marcações existentes para o player

      // for(var i = 0; i < this.state.bookmarks.length; i++) {
      //   this.deleteBookmark(this.state.bookmarks[i]);
      // }
      this.sendBookmarksToPlayer();
      return;
    }

    // if(requestEpubJsonData){
    //   const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    //   if (iframe?.contentWindow) {
    //     iframe.contentWindow.postMessage({
    //       requestEpubJsonData: true
    //     }, '*');
    //   }
    //   return;
    // }

    if (requestSummary) {
      if (!this.state.summary) {
        await this.loadSummary();
      }
      this.sendSummaryToPlayer();
      return;
    }

    if (createCitation) {
      this.handleCreateCitation(createCitation.text);
      return;
    }

    if (userInteraction) {
      this.handleBookmarkEvent(userInteraction.type, userInteraction.userData);
    }
    this.sendBookmarksToPlayer();
    this.sendProgressToPlayer();
  }

  handleBookmarkEvent = async (type, userData) => {
    try {
      // Extract target_uid from content URL
      const fileUid = this.state.contentUid;
      const referenceUid = this.state.referenceUid;
      const updatedUserData = { ...userData, target_uid: fileUid || userData.target_uid , context_uid: referenceUid || userData.context_uid };
      
      switch (type) {
        case 'highligth': // Manter typo para compatibilidade
          await this.createBookmark(updatedUserData);
          break;
        case 'note':
          await this.updateBookmark(updatedUserData);
          break;
        case 'delete':
          await this.deleteBookmark(updatedUserData);
          break;
        case 'trackProgress':
          await this.saveProgress(updatedUserData);
          break;
      }
      // Recarregar marcações após operação
      await this.loadBookmarks();
      await this.sendBookmarksToPlayer();
    } catch (error) {
      console.error('Error handling bookmark event:', error);
    }
  }

  createBookmark = async (bookmarkData) => {
    // const connectors = Sdk.Api.authorization.user.directory.connectors;
    const connectors = Sdk.Api.authorization.activeProject.connectors;
    const connectorUser = connectors?.find(c => c.type === "UserData_1");
    
    if (!connectorUser) {
      throw new Error('UserData connector not found');
    }

    // Determine external_type based on content reference type
    const externalType = this.getExternalTypeForBookmark();

    const userDataParams = {
      ...bookmarkData,
      external_type: externalType,
      target_type: "ManagedContentReference",
      context_type: "ManagedContent",
      context_uid: this.state.contentUid,
      target_uid: this.state.referenceUid,
      name: null,
    };

    const url = `cms/v1.1/user/connector/uid/${connectorUser.uid}/data`;
    return await Sdk.Api.dynamic.bridge(url, userDataParams, "POST");
  }

  updateBookmark = async (bookmarkData) => {
    const bookmarkUid = bookmarkData.uid;
    if (!bookmarkUid) return;

    const url = `cms/v1.1/user/data/uid/${bookmarkUid}`;
    const updates = {
      description: bookmarkData.description,
      external_data: bookmarkData.external_data,
    };
    return await Sdk.Api.dynamic.bridge(url, updates, "PUT");
  }

  deleteBookmark = async (bookmarkData) => {
    const bookmarkUid = bookmarkData.uid;
    if (!bookmarkUid) return;

    const url = `cms/v1.1/user/data/uid/${bookmarkUid}`;
    return await Sdk.Api.dynamic.bridge(url, null, "DELETE");
  }

  loadBookmarks = async () => {
    if (!this.state.referenceUid) return;
    
    try {
      const url = `cms/v1.1/user/data?target_uid=${this.state.referenceUid}`;
      const response = await Sdk.Api.dynamic.bridge(url, null, "GET");
      
      if (response.result) {
        const bookmarks = response.result.filter(item => 
          item.target_type === "ManagedContentReference" && 
          item.context_type === "ManagedContent"
        );
        this.setState({ bookmarks });
      }
    } catch (error) {
      console.error('Error loading bookmarks:', error);
    }
  }

  sendBookmarksToPlayer = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow) {
      const mimeType = this.getMimeTypeFromReference();
      
      if (mimeType === 'application/epub+zip') {
        // Estrutura para EPUB
        iframe.contentWindow.postMessage({
          userData: JSON.stringify(this.state.bookmarks),
          lastInteraction: this.state.lastInteraction,
          type: "RDPEvent:user_interaction"
        }, '*');
      } else {
        // Estrutura para PDF
        iframe.contentWindow.postMessage({
          loadHighlights: this.state.bookmarks
        }, '*');
      }
    }
  }

  sendAppVersion = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage({
        app_version: "v4"
      }, '*');
    }
  }

  loadProgress = async () => {
    if (!this.state.referenceUid) return;

    try {
      // First create interaction by accessing content
      const contentUrl = `cms/v1.1/managed/content/reference/uid/${this.state.referenceUid}/content`;
      await Sdk.Api.dynamic.bridge(contentUrl, null, "GET");
      
      // Then get the interaction data
      const interactionUrl = `cms/v1.1/managed/content/reference/uid/${this.state.referenceUid}/interaction`;
      const response = await Sdk.Api.dynamic.bridge(interactionUrl, null, "GET");
      
      if (response) {
        this.setState({ lastInteraction: response });
        return response;
      }
    } catch (error) {
      console.error('Error loading progress:', error);
    }
    return null;
  }

  saveProgress = async (progressData) => {
    if (!this.state.lastInteraction) return;
    // const connectors = Sdk.Api.authorization.user.directory.connectors;
    const connectors = Sdk.Api.authorization.activeProject.connectors;
    const connectorUser = connectors?.find(c => c.type === "UserData_1");
    try {
      const params = {
        ...this.state.lastInteraction,
        ...progressData,
        activity_data: JSON.stringify(progressData.activity_data),
      };

      // console.log(progressData)
      
      // Avoid duplicate updates
      if (this.state.lastInteraction.activity_data === params.activity_data) return;
      
      const url = `cms/v1.1/managed/content/interaction/uid/${this.state.lastInteraction.uid}`;
      const result = await Sdk.Api.dynamic.bridge(url, params, "PUT");
      
      this.setState({ lastInteraction: result });
      return result;
    } catch (error) {
      console.error('Error saving progress:', error);
      throw error;
    }
  }

  sendProgressToPlayer = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow && this.state.lastInteraction) {
      let progressData = this.state.lastInteraction;

      const mimeType = this.getMimeTypeFromReference();
      
      if (mimeType === 'application/epub+zip') {
        // Estrutura para EPUB
        console.log(this.state.lastInteraction)
        iframe.contentWindow.postMessage({
          lastInteraction: this.state.lastInteraction,
          type: "RDPEvent:user_interaction",
        }, '*');
      } else {
        if (typeof progressData.activity_data === 'string') {
          try {
            progressData = {
              ...progressData,
              data: JSON.parse(progressData.activity_data)
            };
          } catch (e) {
            console.error('Error parsing progress data:', e);
          }
        } else if (progressData.activity_data) {
          progressData = {
            ...progressData,
            data: progressData.activity_data
          };
        }

        iframe.contentWindow.postMessage({
          loadProgress: progressData
        }, '*');
      }    
      
    }
  }

  copySelectedText = async(text) => {
    const {book} = this.state;
    const authors = await AuthorService.updateContentAuthor(book, await AuthorService.loadAuthors(), ', ');
    const year = book.properties.find(x => x.name === 'Ano de Publicação')?.value || '';
    try {
      const formattedText = `
      "${text}"      
      
      ${authors.trim()}, ${book.name}, São Paulo, Editora Senac, ${year}, Disponível na Biblioteca Digital Senac. 
      `;
      navigator.clipboard.writeText(formattedText);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }

  }

  handleCreateCitation = async (text) => {
    let success = false;
    try {
      await this.copySelectedText(text);
      success = true;
    } catch (error) {
      console.error('Error creating citation:', error);
    }
    
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage({
        citationStatus: { success }
      }, '*');
    }
  }

  extractFileUidFromUrl = (url) => {
    if (!url) return null;
    const match = url.match(/reference\/uid\/([^/]+)/);
    return match ? match[1] : null;
  }

  loadSummary = async () => {
    if (!this.state.referenceUid || !this.state.book) return;
    
    this.setState({ summaryLoading: true });
    
    try {
      const mimeType = this.getMimeTypeFromReference();
      let summary = null;
      
      if (mimeType === 'application/epub+zip') {
        summary = await this.getEpubSummary(this.state.referenceUid);
      } else if (mimeType === 'digitalpages/pdf') {
        summary = await this.getPdfSummary(this.state.referenceUid);
      }
      
      this.setState({ 
        summary: summary,
        summaryLoading: false 
      });
    } catch (error) {
      console.error('Error loading summary:', error);
      this.setState({ 
        summary: null,
        summaryLoading: false 
      });
    }
  }

  getMimeTypeFromReference = () => {
    // Determina o tipo MIME baseado na referência atual
    const { book, referenceUid } = this.state;
    if (book && book.references && referenceUid) {
      const reference = book.references.find(ref => ref.uid === referenceUid);
      if (reference) {
        return reference.mime_type;
      }
    }
    
    // Fallback para URL se não encontrar na referência
    const url = this.state.url;
    if (url && url.includes('epub')) {
      return 'application/epub+zip';
    } else if (url && url.includes('pdf')) {
      return 'digitalpages/pdf';
    }
    return 'application/epub+zip'; // Default to epub
  }

  getExternalTypeForBookmark = () => {
    const mimeType = this.getMimeTypeFromReference();
    if (mimeType === 'digitalpages/pdf') {
      return 'mark-pdf';
    }
    return 'mark-epub'; // Default for epub and other types
  }

  getEpubSummary = async (uid) => {
    try {
      const url = `cms/v1.1/managed/content/reference/uid/${uid}/default/target`;
      const response = await Sdk.Api.dynamic.bridgeUrl(url, null);
      
      // Validar URL antes de fazer fetch
      if (!this.validateUrl(response)) {
        throw new Error('Invalid URL for content fetch');
      }
      
      const contentToc = await fetch(response);
      const contentTocUrl = contentToc.url.replace("content.opf?", "toc.ncx?");
      
      // Validar URL do TOC
      if (!this.validateUrl(contentTocUrl)) {
        throw new Error('Invalid URL for TOC fetch');
      }
      
      const manifest = await fetch(contentTocUrl).then(p => p.text());
      
      const parser = new DOMParser();
      const xml = parser.parseFromString(manifest, "text/xml");
      const navPoints = xml.getElementsByTagName("navPoint");
      
      return this.parseEpubSummary(navPoints);
    } catch (error) {
      console.error('Error getting ePUB summary:', error);
      return null;
    }
  }

  validateUrl = (url) => {
    try {
      const urlObj = new URL(url);
      // Lista de domínios permitidos
      const allowedDomains = [
        'api.digitalpages.com.br',
        'digitalpages.com.br'
      ];
      
      // Verificar se o domínio está na lista permitida
      if (!allowedDomains.includes(urlObj.hostname)) {
        throw new Error('Domain not allowed');
      }
      
      // Bloquear IPs privados
      const privateIpRegex = /^(127\.|10\.|172\.(1[6-9]|2[0-9]|3[01])\.|192\.168\.|169\.254\.)/;
      if (privateIpRegex.test(urlObj.hostname)) {
        throw new Error('Private IP not allowed');
      }
      
      return true;
    } catch (error) {
      console.error('URL validation failed:', error);
      return false;
    }
  }

  parseEpubSummary = (navPoints) => {
    const result = [];
    
    const removeExtraSpace = (s) => 
      s?.trim()
       .split(/ +/)
       .join(" ")
       .replace(/(\r\n|\n|\r)/gm, "");
    
    Array.from(navPoints).forEach((navPoint) => {
      const content = navPoint.getElementsByTagName('content')[0];
      const navLink = content?.getAttribute('src');
      
      result.push({
        type: "epub",
        uid: navPoint.id?.toString(),
        title: removeExtraSpace(navPoint.textContent),
        navLink
      });
    });
    
    return result;
  }

  getPdfSummary = async (uid) => {
    try {
      const url = `cms/v1.1/managed/content/reference/uid/${uid}/default/target`;
      const response = await Sdk.Api.dynamic.bridge(url, null, "GET");
      
      if (response && response.sections) {
        return this.parsePdfSummary(response);
      }
      
      return null;
    } catch (error) {
      console.error('Error getting PDF summary:', error);
      return null;
    }
  }

  parsePdfSummary = (serverData) => {
    const result = [];
    
    if (serverData && serverData.sections) {
      const pageSets = serverData.sections[0].pageSets;
      
      pageSets.forEach((pageSet) => {
        const navLink = {
          page: pageSet.orderIndex,
          section: pageSet.sectionIndex
        };
        
        result.push({
          type: "pdf",
          uid: pageSet.portrait.linkPage,
          title: pageSet.portrait.bookmark,
          navLink: JSON.stringify(navLink)
        });
      });
    }
    
    return result;
  }

  sendSummaryToPlayer = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow && this.state.summary) {
      iframe.contentWindow.postMessage({
        loadSummary: this.state.summary
      }, '*');
    }
  }

  async getReferences() {
    var file = this.props.match.params.file;
    var reference = this.props.match.params.reference;
    var groupedContent = await Utils.bridgeAndStore(`/cms/v1.1/managed/content/group/uid/${file}`);
    // var references = groupedContent.references;
    // var uid = references.find(item => item.mime_type === "application/epub+zip").uid;
    // var pdf = references.find(item => item.mime_type === "application/pdf");

    // if (pdf !== undefined) { uid = pdf.uid };

    var content = await Sdk.Api.dynamic.bridgeUrl(`cms/v1.1/managed/content/reference/uid/${reference}/content`, null);
    content += "&app_version=v4";

    // content = "http://localhost:3001/?custom_options=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";

    this.setState({
      "contentUid": file,
      "book": groupedContent,
      "referenceUid": reference,
    });

    // Carregar marcações e progresso
    await this.loadBookmarks();
    await this.loadProgress();
    
    this.state.bookmarks.forEach(bookmark => {

      // // console.log( bookmark);
      // if(bookmark.external_type === 'reading-progress') {
      //   console.log("deleting wrong bookmark");
      //   this.deleteBookmark(bookmark);
      // }
    }
    );  

    this.setState({
      "url": content,
    });
    
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  getCustomOptions() {
    return `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`;
  }

  render() {
    const { url } = this.state;
    var _this = this;
    return <div className="rdp-react-template-view-livro">
      {url === null &&
        <Preloader/>
      }
      {url !== null &&
        <iframe 
          className="rdp-react-template-view-livro-iframe" 
          title="book-player"
          onLoad={(e) => {
            // e.target.contentWindow.postMessage({
            //   app_version: "v4"
            // }, '*');
            // Enviar dados iniciais para o player
              const mimeType = this.getMimeTypeFromReference();
              
              if (mimeType === 'application/epub+zip') {
                // Estrutura para EPUB (seguindo js_app_senac)
                e.target.contentWindow.postMessage({
                  userData: JSON.stringify(this.state.bookmarks),
                  lastReference: null,
                  navigateTo: null,
                  lastInteraction: this.state.lastInteraction,
                  type: "RDPEvent:user_interaction",
                  app_version: "v4"
                }, '*');
              } else {
                // console.log("frame load", this.state.bookmarks, this.state.lastInteraction);
                // Estrutura unificada para PDF (seguindo padrão EPUB)
                e.target.contentWindow.postMessage({
                  loadHighlights: this.state.bookmarks,
                  loadProgress: this.state.lastInteraction,
                  app_version: "v4"
                }, '*');
              }
            }
          }
          src={url}
        />
      }
    </div>;
  }
}
